import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './Pages/LandingPage/LandingPage';
// import ProductsPage from "./Pages/ProductsPage/ProductsPage";
import GalleryPage from "./Pages/GalleryPage/GalleryPage";
import ContactPage from "./Pages/ContactPage/ContactPage";
import AboutPage from "./Pages/AboutPage/AboutPage";
import PrivacyPolicy from "./Pages/QuickLinks/PrivacyPolicy";
import TermsAndConditions from "./Pages/QuickLinks/TermsAndConditions";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* <Route path="/Products" element={<ProductsPage />} /> */}
        <Route path="/Gallery" element ={<GalleryPage/>} />
        <Route path="/ContactUs" element ={<ContactPage/>} />
        <Route path="/AboutUs" element ={<AboutPage/>} />
        <Route path="/PrivacyPolicy" element ={<PrivacyPolicy/>} />
        <Route path="/TermsAndConditions" element ={<TermsAndConditions/>} />
      </Routes>
    </Router>
  );
}

export default App;
